import { render, staticRenderFns } from "./Armyintroduce.vue?vue&type=template&id=70959d3d&scoped=true&"
import script from "./Armyintroduce.vue?vue&type=script&lang=js&"
export * from "./Armyintroduce.vue?vue&type=script&lang=js&"
import style0 from "./Armyintroduce.vue?vue&type=style&index=0&id=70959d3d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70959d3d",
  null
  
)

export default component.exports